import * as schemaUploadedFiles from "~/schemas/schema.uploaded_files.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import upload from "~/utils/upload.jsx";

const uploads = {};

const saveUploadRequest = (xhr, code) => {
  uploads[code] = xhr;
};

const forgetUploadRequest = (code) => {
  if (uploads[code]) delete uploads[code];
};

const cancelUploadRequest = (code) => {
  if (uploads[code]) {
    uploads[code].abort();
    delete uploads[code];
    return true;
  }
  return false;
};

const cancelAllUploadRequests = () => {
  Object.keys(uploads).forEach(cancelUploadRequest);
};

const processingFileUpload = (file, progress) => {
  return {
    type: actionTypes.UPLOAD_FILE_LOADING,
    file,
    progress,
  };
};

export const uploadFile =
  (file, formKey = ``) =>
  (dispatch) => {
    const xhr = new XMLHttpRequest();

    saveUploadRequest(xhr, file.code);

    dispatch({
      type: actionTypes.UPLOAD_FILE_BEGINS,
      file,
      formKey,
      schema: schemaUploadedFiles.arrayOfUploadedFiles,
    });

    const xhrUpload = upload(file, (progress) => dispatch(processingFileUpload(file, progress)));

    return xhrUpload(xhr).then(
      (response) => {
        dispatch({
          type: actionTypes.UPLOAD_FILE_SUCCESS,
          file,
          formKey,
          response,
          schema: schemaUploadedFiles.uploadedFile,
        });
        forgetUploadRequest(file.code);
      },
      (error) => {
        dispatch({
          type: actionTypes.UPLOAD_FILE_ERROR,
          file,
          formKey,
          error: error.message || `Unable to upload file`,
        });
        forgetUploadRequest(file.code);
      }
    );
  };

export const removeUploadedFile = (code) => {
  cancelUploadRequest(code);

  return {
    type: actionTypes.REMOVE_UPLOADED_FILE,
    code,
  };
};

export const removeUnfinishedFileUploads = (formKey = ``) => {
  cancelAllUploadRequests(uploads);

  return {
    type: actionTypes.REMOVE_UNFINISHED_FILE_UPLOADS,
    formKey,
  };
};

export const uploadGoogleDriveFiles = (docs, formKey = ``) => {
  return {
    types: [
      actionTypes.UPLOAD_GDRIVE_FILES_LOADING,
      actionTypes.UPLOAD_GDRIVE_FILES_SUCCESS,
      actionTypes.UPLOAD_GDRIVE_FILES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/integrations/google-drive/batch`,
        method: `post`,
        body: { docs },
      }),
    payload: {
      docs,
      formKey,
      schema: schemaUploadedFiles.arrayOfUploadedFiles,
    },
  };
};

export const uploadDropboxFiles = (files, formKey = ``) => {
  return {
    types: [
      actionTypes.UPLOAD_DROPBOX_FILES_LOADING,
      actionTypes.UPLOAD_DROPBOX_FILES_SUCCESS,
      actionTypes.UPLOAD_DROPBOX_FILES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/integrations/dropbox/batch`,
        method: `post`,
        body: { files },
      }),
    payload: {
      files,
      formKey,
      schema: schemaUploadedFiles.arrayOfUploadedFiles,
    },
  };
};

export const resetUploadedFiles = () => {
  return {
    type: actionTypes.RESET_UPLOADED_FILES,
  };
};

export const addUploadedFile = (file) => {
  return {
    type: actionTypes.ADD_UPLOADED_FILE,
    response: [file],
    schema: schemaUploadedFiles.arrayOfUploadedFiles,
  };
};

export const addDropboxFiles = (files) => {
  return {
    type: actionTypes.ADD_DROPBOX_FILES,
    response: files,
    schema: schemaUploadedFiles.arrayOfUploadedFiles,
  };
};

export const addGoogleDriveFiles = (files) => {
  return {
    type: actionTypes.ADD_GDRIVE_FILES,
    response: files,
    schema: schemaUploadedFiles.arrayOfUploadedFiles,
  };
};
